import { useMemo } from 'react';
import { useCompanyContext } from '@/hooks/useCompanyContext';
import type { ICompanyRoleContext } from '@/@types/company';

export function useCompanyRole(): ICompanyRoleContext {
  const { companyRoles } = useCompanyContext();

  return useMemo(() => {
    const isAdmin = companyRoles.includes('admin');
    const isManager = companyRoles.includes('manager');
    const isEmployee = companyRoles.includes('employee');
    const isAccountant = companyRoles.includes('accountant');

    return {
      isAdmin,
      isManager,
      isEmployee,
      isAccountant,
      canEditEmployees: isAdmin || isManager,
      canViewInvoices: isAdmin || isAccountant,
      canUploadReceipts: isAdmin || isAccountant,
      canManageTeam: isAdmin,
      canViewAllPolicies: isAdmin || isManager || isAccountant,
      canViewOwnPoliciesOnly: !(isAdmin || isManager || isAccountant),
    };
  }, [companyRoles]);
}
